import React, { useState } from "react";
import { auth, db } from "../../../firebase";
import { push, ref, serverTimestamp } from "firebase/database";
import axios from "axios";
import { NOTIFICATION_URL } from "../../../utils/common.data";

const SendMessage = ({ scroll, tripID, driverFireId, tripDetail }) => {
  const apikey = sessionStorage.getItem("key");
  const userid = sessionStorage.getItem("userid");
  const [input, setInput] = useState("");
  const [fullname, setfullname] = useState(sessionStorage.getItem("name"));
  // const [phone, setphone] = useState(sessionStorage.getItem("phone"));
  // const [err, setErr] = useState("");

  const handleChange = (e) => {
    setInput(e.target.value);
    // setErr("");
  };

  const sendMessage = async (e) => {
    e.preventDefault();
    if (input === "" || input?.trim() == "") {
      // setErr("Please enter a valid message");
      return;
    }
    const { uid } = auth.currentUser;
    const tripIdValue = tripID
    const messagesRef = ref(db, 'Chats/' + tripIdValue); // Reference to your 'Chats' node in Realtime Database
    const messageData = {
      text: input,
      id: userid,
      isUser: true,
      is_user: true,
      is_read: false,
      user_name: fullname,
      to: driverFireId,
      trip_id: tripID,
      from: uid,
      timeStamp: serverTimestamp(),
    }
    // console.log(messageData);
    push(messagesRef,messageData)
    .then(() => {
      console.log('Data inserted successfully!');
      setInput("");
      scroll.current.scrollIntoView({ behavior: "smooth" });
      sendNotificationDriver(messageData.text)
    })
    .catch((error) => {
      console.error('Error inserting data: ', error);
    });
  };

  const sendNotificationDriver = async (message) => {
    if (!tripDetail || !tripDetail?.Driver) return;

    let params = {
      message: message,
      trip_id: tripDetail.tripId,
      trip_status: "chat"
    };

    if (tripDetail.is_delivery === "1") {
      params.delivery_id = tripDetail.tripId;
    }
    let isAndroid = tripDetail?.Driver?.d_device_type.toLowerCase() === "android";
    if (isAndroid) {
      params.android = tripDetail?.Driver?.d_device_token;
    } else {
      params.ios = tripDetail?.Driver?.d_device_token;
    }

    try {
      const response = await axios.post(`${NOTIFICATION_URL}?api_key=${apikey}`,params)

    } catch (e) {
      console.error("sendNotification:", e.message, e);

    }
  }

  return (
    <form onSubmit={sendMessage} className="chat_message_form">
      <input
        value={input}
        onChange={handleChange}
        className="chat_message_input"
        type="text"
        placeholder="Type Message..."
      />
      <button className="chat_message_button" type="submit">
        <i className="fas fa-paper-plane"></i>
      </button>
      {/* {err && <p className="chat_message_err">{err}</p>} */}
    </form>
  );
};

export default SendMessage;
